import getIPC from 'node-ipc-promise';

const ipc = getIPC();

export function send(message, ...args): Promise<any> {
  return ipc.exec(message, ...args);
}
